(function() {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivitiesAttachmentList', rmsActivitiesAttachmentList);

    function rmsActivitiesAttachmentList() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsActivitiesAttachmentListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/list-panel/activities-attachments-list'
        };
    }

    function rmsActivitiesAttachmentListCtrl(ActivitiesService, lodash) {
        const vm = this;
        this.$onInit = function() {
            vm.removeAttachment = removeAttachment;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function removeAttachment(attachment) {
            const index = lodash.findIndex(vm.pageData.inputData.model.attachments, {select_id: attachment.select_id});
            vm.pageData.inputData.model.attachments.splice(index, 1);
        }
    }
})();